import { getSpaceRolesGQLQuery } from '../../graphql/index.js';
export class SpaceRolesClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getSpaceRolesGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.spaceRoles;
    }
}
//# sourceMappingURL=spaceRoles.client.js.map